import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { logoutUser } from '../../pages/auth/login/actions';

import PropTypes from 'prop-types';
import Title from './Title/index';
import ButtonsHeader from './ButtonsHeader';
import Breadcrumb from '../Breadcrumb';
import UserPanel from './UserPanel/index';
import { HeaderPage, ContentHeader, SubtitleHeader, StagingBanner } from './header.styles';
import { ResumeButton } from "./../../pages/operational/request/resume/requestResume.styles";


import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

class Header extends PureComponent {

  static defaultProps = {
    isTab: false,
    breadcrumb: [],
    headerLinks: [],
    cancel: () => {},
    confirm: () => {},
    disabledCancel: false,
    disabledConfirm: false,
    formName: '',
    titleIcon: '',
    messageIcon: undefined,
    onClickTitleIcon: () => {},
    openTourCallback: () => {},
    leftHeaderAction: null
  }

  renderThirdRow = () => {
    switch(this.props.typeHeader){
      case "form":
        return (
          <StyledRow customstyle="height: 59px;" align="flex-end">
            <ButtonsHeader 
              headerLinks={this.props.headerLinks} 
              cancel={this.props.cancel} 
              confirm={this.props.confirm}
              disabledCancel={this.props.disabledCancel}
              disabledConfirm={this.props.disabledConfirm}
              formName={this.props.formName}
              confirmIcon={this.props.proccess}
              cancelIcon={this.props.proccess} />
          </StyledRow>);
      default:
        return this.props.children && this.props.children;
    }
  }

  renderButtonTour = () => {
    const pathPermited = [
      '/intranet/dashboard',
      '/intranet/operacional/solicitacao',
      '/intranet/operacional/solicitacao/adicionar/selecionar-produto',
      '/intranet/operacional/solicitacao/formulario',
      '/intranet/operacional/solicitacao/laudo',
      '/intranet/operacional/solicitacao/resumo',
      '/intranet/operacional/solicitacao/resumo/locacao',
      '/intranet/operacional/solicitacao/resumo/pretendente',
      '/intranet/operacional/solicitacao/resumo/adicionar/fc-renda',
      '/intranet/operacional/solicitacao/resumo/adicionar-pretendente',
      '/intranet/cadastro/dados-cliente',
      '/intranet/cadastro/usuarios',
      // '/intranet/cadastro/customizar-recomendacoes',
      '/intranet/financeiro/relatorio',
      '/intranet/financeiro/segunda-via-boleto',
      // '/intranet/consumo/precos'
    ]

    // if(this.props.master) {
    //   pathPermited.push('/intranet/cadastro/usuarios');
    // }

    if(this.props.forceRenderButtonTour) {
      return(
        <ResumeButton style={{position: 'absolute', bottom: 1, backgroundColor: '#ff7200', color: '#152b4e', width: '11rem', padding: '.25rem 0.5rem .25rem 0.5rem', marginLeft: -44}} onClick={this.handleOpenTour}>
          Tour do Sistema (v.Beta)
        </ResumeButton>
      )
    }

    if(!pathPermited.includes(window.location.pathname)) {
      return null
    }

    return(
      <ResumeButton style={{position: 'absolute', bottom: 1, backgroundColor: '#ff7200', color: '#152b4e', width: '11rem', padding: '.25rem 0.5rem .25rem 0.5rem', marginLeft: -44}} onClick={this.handleOpenTour}>
        Tour do Sistema (v.Beta)
      </ResumeButton>
    )
  }

  renderButtonNps = () => {
    const pathPermited = [
      '/intranet/dashboard'
    ]

    if(!pathPermited.includes(window.location.pathname)) {
      return null
    }

    const { login } = this.props;
    const showStorageNps = localStorage.getItem('ja_respondeu_nps') === 'true' ? false : true;
    if(login.user && login.user.pesquisa && login.user.pesquisa.ja_respondeu === true || showStorageNps === false) {
      return null;
    }

    return(
      <ResumeButton style={{position: 'absolute', bottom: 1, backgroundColor: '#ff7200', color: '#152b4e', width: '11rem', padding: '.25rem 0.5rem .25rem 0.5rem', marginLeft: -44}} onClick={this.props.openNps}>
        Avalie a FC ANALISE
      </ResumeButton>
    )
  }

  handleOpenTour = () => {
    this.props.openTourCallback(true)
  }

  render() {
    const hasLeftHeaderAction = !!this.props.leftHeaderAction;
    const isLaudoHeader = this.props.actualLink === 'Laudo';
    const colLeft = hasLeftHeaderAction ? 5 : 4;
    const colCenter = hasLeftHeaderAction ? (isLaudoHeader ? 2 : 3) : 3;
    const colRight = hasLeftHeaderAction ? (isLaudoHeader ? 5 : 4) : 5;
    const isStage = process.env.REACT_APP_ENV === 'stage';

    return (
        <HeaderPage height={this.props.height} isTab={this.props.isTab} className='headerPage'>
          {isStage && (
            <StagingBanner>
              você está em um ambiente de testes da FC ANALISE
            </StagingBanner>
          )}
          <ContentHeader>
            <img src='https://cliente.ficharapida.rio.br/print/img/logo-fc-f-claro.png' style={{display: 'none'}} className='logo-print' />
            <StyledRow>
              <BaseColumn xs="12" sm="12" md="12" lg="12" xl="12">
                <StyledRow>
                  <BaseColumn xs="12" md={colLeft} lg={colLeft} xl={colLeft} customstyle={{ alignItems: 'center' }} className='content-header-1'>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'nowrap', minWidth: 0}}>
                      <div style={{width: 'auto', flex: '0 1 auto', minWidth: 0}}>
                        <Breadcrumb links={this.props.breadcrumb} actualLink={this.props.actualLink} />
                      </div>
                      <div style={{display: 'inline-flex', alignItems: 'center', flex: '0 0 auto'}}>
                        {this.props.leftHeaderAction}
                      </div>
                    </div>
                  </BaseColumn>

                  <BaseColumn xs="12" md={colCenter} lg={colCenter} xl={colCenter} customstyle={{ alignItems: 'center' }} className='content-header-2'>
                    <Title 
                      title={this.props.title} 
                      icon={this.props.titleIcon} 
                      iconClick={this.props.onClickTitleIcon}
                      message={this.props.messageIcon} />
                    { this.props.subtitle && 
                      <StyledRow justify="center">
                        <SubtitleHeader style={{color: '#000'}}>{this.props.subtitle}</SubtitleHeader>
                      </StyledRow> }
                  </BaseColumn>

                  <BaseColumn xs="12" md={colRight} lg={colRight} xl={colRight} customstyle={{ alignItems: 'center' }} className='content-header-3'>
                    {/* {this.renderButtonTour()} */}
                    {/* {this.renderButtonNps()} */}
                    <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', flexWrap: 'nowrap'}}>
                      <div style={{display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap', flex: '0 0 auto', marginLeft: 'auto'}}>
                        {this.props.actualLink === 'Laudo' &&
                          <div
                            className="botao-imprimir-pdf no-print-impressao-pdf"
                            style={{position: 'relative', top: '-5px', padding: '6px 10px 8px', borderRadius: 12, border: '1px solid rgba(21, 43, 78, 0.1)', background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)', boxShadow: '0 2px 10px rgba(21, 43, 78, 0.09)', textAlign: 'center'}}
                          >
                            <span style={{color: '#152b4e', fontSize: '.65rem', fontWeight: 600, letterSpacing: '.02em', textTransform: 'uppercase', lineHeight: 1}}>Impressão/PDF</span>
                            <div style={{display: 'flex', justifyContent: 'center', gap: '5px', marginTop: 4}}>
                              <ResumeButton disabled={this.props.disableButtonPrintLaudo} style={{bottom: 1, backgroundColor: '#152b4e', color: '#fff', width: 'auto', minWidth: this.props.infos && Boolean(this.props.infos.recibo) ? '2.75rem' : '3.35rem', padding: '.2rem .4rem', margin: 0, letterSpacing: '.01em'}} onClick={this.props.handleImpressao} customstyle="&:disabled {cursor: no-drop;}">
                                LAUDO
                              </ResumeButton>
                              <ResumeButton disabled={this.props.disableButtonPrintLaudo} style={{bottom: 1, backgroundColor: '#152b4e', color: '#fff', width: 'auto', minWidth: this.props.infos && Boolean(this.props.infos.recibo) ? '2.75rem' : '3.35rem', padding: '.2rem .4rem', margin: 0, letterSpacing: '.01em'}} onClick={this.props.handleImpressaoResumida} customstyle="&:disabled {cursor: no-drop;}">
                                RESUMO
                              </ResumeButton>
                              {this.props.infos && Boolean(this.props.infos.recibo) ? (
                                <ResumeButton disabled={this.props.disableButtonPrintLaudo} style={{bottom: 1, backgroundColor: '#152b4e', color: '#fff', width: 'auto', minWidth: '2.75rem', padding: '.2rem .4rem', margin: 0, letterSpacing: '.01em'}} onClick={this.props.getPrintRecibo} customstyle="&:disabled {cursor: no-drop;}">
                                  RECIBO
                                </ResumeButton>
                              ) : null}
                              {this.props.showWhatsappLaudo ? (
                                <ResumeButton disabled={this.props.disableButtonPrintLaudo} style={{bottom: 1, backgroundColor: '#152b4e', color: '#fff', width: 'auto', minWidth: '4.5rem', padding: '.2rem .4rem', margin: 0, letterSpacing: '.01em'}} onClick={this.props.enviarLaudoWhatsapp} customstyle="&:disabled {cursor: no-drop;}">
                                  WHATSAPP
                                </ResumeButton>
                              ) : null}
                            </div>
                          </div>
                        }
                        <UserPanel logout={this.props.logoutUser} />
                      </div>
                    </div>
                  </BaseColumn>
                </StyledRow>
              </BaseColumn>          
            </StyledRow>
            
            {this.renderThirdRow()}
          </ContentHeader>
        </HeaderPage>
    ); 
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  cancel: PropTypes.func,
  confirm: PropTypes.func
};

const mapDispatchToProps = dispatch => bindActionCreators({ logoutUser }, dispatch)

const mapStateToProps = (state) => ({
  login: state.login
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
